import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { ActionTypes } from '../../constants/ActionTypes';
import { fetchError } from '../actions/Common';
import { fetchLetterFolderListSuccess } from '../actions';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

const getLetterFolderList = async (str: string | null) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`letter/getLetterFolderList?searchText=${str || ''}`);
};

function* fetchLetterFolderListRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedLetterFolderList = yield call(
      getLetterFolderList,
      action.payload,
    );
    yield put(fetchLetterFolderListSuccess(fetchedLetterFolderList.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterFolderList() {
  yield takeEvery(
    ActionTypes.GET_LETTERFOLDER_LIST,
    fetchLetterFolderListRequest,
  );
}

export default function* rootSaga() {
  yield all([fork(fetchLetterFolderList)]);
}
